import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function VirtualWeeklyActiveChart({ virtualId, API_BASE }) {
    const [data, setData] = useState([]);

    useEffect(() => {
        async function load() {
            const res = await fetch(`${API_BASE}/virtual/${virtualId}/daily-active`);
            const json = await res.json();

            const formatted = (json.history || []).map(d => ({
                ...d,
                // TR formatlı gün
                labelDay: new Date(d.day).toLocaleDateString("tr-TR", {
                    day: "2-digit",
                    month: "2-digit"
                })
            }));

            setData(formatted);
        }
        load();
    }, [virtualId, API_BASE]);

    return (
        <div className="bg-white border p-5 rounded-xl shadow">
            <h3 className="text-sm font-semibold mb-3">7 Günlük Aktif Enerji Tüketimi</h3>

            <ResponsiveContainer width="100%" height={260}>
                <BarChart data={data}>
                    <XAxis dataKey="labelDay" />   {/* ✔️ düzgün gün */}
                    <YAxis />
                    <Tooltip
                        formatter={(v) => `${v.toLocaleString("tr-TR")} kWh`}
                        labelFormatter={(label) => `${label} tarihi`}
                    />
                    <Bar dataKey="daily_import" fill="#10B981" name="Import" />
                    <Bar dataKey="daily_export" fill="#F59E0B" name="Export" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
